import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { FloatingCTA } from "@/components/FloatingCTA";
import { IntroSplash } from "@/components/IntroSplash";
import Home from "@/pages/Home";
import Plans from "@/pages/Plans";
import OTT from "@/pages/OTT";
import WhyEway from "@/pages/WhyEway";
import About from "@/pages/About";
import Support from "@/pages/Support";
import Contact from "@/pages/Contact";
import GetConnected from "@/pages/GetConnected";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            return undefined;
        }
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="min-h-screen bg-[#0B0F19] text-slate-100">
            <BrowserRouter>
                <ScrollToTop />
                <Navbar />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/plans" element={<Plans />} />
                        <Route path="/ott" element={<OTT />} />
                        <Route path="/why-eway" element={<WhyEway />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/support" element={<Support />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/get-connected" element={<GetConnected />} />
                        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                        <Route path="/terms-and-conditions" element={<Terms />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </main>
                <Footer />
                <FloatingCTA />
                <IntroSplash />
                <Toaster theme="dark" position="top-center" richColors />
            </BrowserRouter>
        </div>
    );
}

export default App;
